// extracted by mini-css-extract-plugin
export default {"controls":"CineControls-styles-module--controls--qf9j5"};